module.exports = __webpack_public_path__ + "static/media/cloud-computing.2a2f9c9e.svg";